<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Portal-Document-Policy-Upload",
  short_name: "Upload Policy Document",
  path: "upload",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
